module.exports = __webpack_public_path__ + "img/success-qr.7f86e719.png";